"use strict";
/**
 * Text size constants
 * Defines available text lengths for generation
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXT_SIZE_CONFIGS = exports.TextSizes = void 0;
exports.isTextSize = isTextSize;
exports.getTextLengthRange = getTextLengthRange;
exports.TextSizes = ["SHORT", "MEDIUM", "LONG"];
function isTextSize(size) {
    return !!size && exports.TextSizes.includes(size);
}
exports.TEXT_SIZE_CONFIGS = {
    SHORT: {
        name: "SHORT",
        minWords: 50,
        maxWords: 150,
        description: "Short text (50-150 words)",
    },
    MEDIUM: {
        name: "MEDIUM",
        minWords: 151,
        maxWords: 300,
        description: "Medium text (151-300 words)",
    },
    LONG: {
        name: "LONG",
        minWords: 301,
        maxWords: 500,
        description: "Long text (301-500 words)",
    },
};
const CJK_TEXT_LENGTH_RANGES = {
    SHORT: { min: 300, max: 600, unit: "characters" },
    MEDIUM: { min: 600, max: 1200, unit: "characters" },
    LONG: { min: 1200, max: 2200, unit: "characters" },
};
/** Return the generation and validation range in the language's length unit. */
function getTextLengthRange(textSize, language) {
    const normalizedLanguage = (language || "").trim().toLowerCase();
    const languageCode = normalizedLanguage.split(/[-_]/)[0];
    const cjkAliases = [
        "cn",
        "chinese",
        "汉语",
        "中文",
        "japanese",
        "日本語",
        "korean",
        "한국어",
    ];
    if (["zh", "ja", "ko"].includes(languageCode) ||
        cjkAliases.includes(normalizedLanguage)) {
        return { ...CJK_TEXT_LENGTH_RANGES[textSize] };
    }
    const { minWords, maxWords } = exports.TEXT_SIZE_CONFIGS[textSize];
    return { min: minWords, max: maxWords, unit: "words" };
}
//# sourceMappingURL=textSizes.js.map